// src/components/Character.js
import React from 'react';

export default function Character({
                                      name = 'Mars',
                                      size = Math.floor(2*window.innerHeight / 5),          // larghezza e altezza
                                      position = 'left',   // 'left' o 'right'
                                      style = {},
                                      isActive = true,
                                  }) {
    let image;
    try {
        image = require(`../assets/characters/${name}.png`);
    } catch (err) {
        console.warn(`Character image for "${name}" not found. Falling back to Mars.`);
        image = require(`../assets/characters/Mars.png`);
    }

    // Posizioni predefinite
    const positions = {
        left: { left: '18%', transform: 'translateX(-50%)' },
        right: { left: '82%', transform: 'translateX(-50%)' },
        reward: { left: '50%', transform: 'translateX(calc(-50% + 380px))' },
    };

    const characterStyle = {
        position: 'fixed',
        bottom: 0,
        pointerEvents: 'none',
        zIndex: isActive ? 100 : 2,
        filter: isActive 
            ? 'brightness(1.2) drop-shadow(0 0 20px rgba(255,255,255,0.4))' 
            : 'brightness(0.5) grayscale(0.4)',
        transition: 'all 0.5s ease-in-out',
        ...positions[position],
        ...style,
    };

    return (
        <div className="character" style={characterStyle}>
            <img
                src={image}
                alt={name}
                style={{ width: 'auto', height: size, objectFit: 'contain' }}
            />
        </div>
    );
}